// src/pages/process/ProcessLayout.jsx
import React from "react";
import { Outlet } from "react-router-dom";
import SidebarLayout from "../../components/common/layout/SidebarLayout";
import Forbidden from "../../components/common/ui/Forbidden";
import { projectMenus } from "../../components/layout/ProjectMenus";

export default function ProcessLayout({ hasPermission }) {
  // if (!hasPermission) return <Forbidden />;

  const { title, base, sections } = projectMenus.process;

  return (
    <SidebarLayout title={title} base={base} sections={sections}>
      <Outlet />
    </SidebarLayout>
  );
}
